import React from 'react';
import { IntlProvider } from 'react-intl';

// This is a way to bridge the gap between monolith locale codes and ours
// TODO: Remove this once more robust solution is done: https://fountain.atlassian.net/browse/NOVA-213
/* istanbul ignore next -- temporary code will be removed in NOVA-213 */
export const mapLocaleCodes = (localeCode: string) => {
  switch (localeCode) {
    case 'bg':
      return 'bg-BG';
    case 'cs':
      return 'cs-CZ';
    case 'da':
      return 'da-DK';
    case 'de':
      return 'de-DE';
    case 'el':
      return 'el-GR';
    case 'es':
      return 'es-ES';
    case 'fi':
      return 'fi-FI';
    case 'fr':
      return 'fr-FR';
    case 'fr-CA':
      return 'fr-CA';
    case 'he':
      return 'he-IL';
    case 'hi-in':
      return 'hi-IN';
    case 'hu':
      return 'hu-HU';
    case 'ht':
      return 'ht-HT';
    case 'id':
      return 'id-ID';
    case 'IL':
      return 'he-IL';
    case 'it':
      return 'it-IT';
    case 'ja':
      return 'ja-JP';
    case 'ka':
      return 'ka-GE';
    case 'kn-in':
      return 'kn-IN';
    case 'ko':
      return 'ko-KR';
    case 'mr-in':
      return 'mr-IN';
    case 'ms':
      return 'ms-MY';
    case 'nl':
      return 'nl-NL';
    case 'nn-NO':
      return 'no-NO';
    case 'or-in':
      return 'or-IN';
    case 'pl':
      return 'pl-PL';
    case 'pt':
      return 'pt-BR';
    case 'ro':
      return 'ro-RO';
    case 'ru':
      return 'ru-RU';
    case 'sv':
      return 'sv-SE';
    case 'ta-in':
      return 'ta-IN';
    case 'te-in':
      return 'te-IN';
    case 'th':
      return 'th-TH';
    case 'tr':
      return 'tr-TR';
    case 'vi':
      return 'vi-VN';
    default:
      return localeCode;
  }
};

type IntlProviderProps = React.ComponentProps<typeof IntlProvider>;

export const defaultRichTextElements: IntlProviderProps['defaultRichTextElements'] =
  {
    b: chunks => <b>{chunks}</b>,
  };

type Locale = string;

export interface LanguageProviderProps {
  locale: Locale;
  timeZone?: string;
}

export type Translations = Record<Locale, Record<string, string>>;
